/* ============================================
   VERSALE — CARD DE PRODUTO: nome e preço alinhados na linha
   O selo "Moissanite certificada" fica acima do nome. Numa linha do grid em que algum card
   tem o selo, os cards sem selo ganham a classe versale-card--badge-space (o CSS guarda o
   espaço do selo) e os nomes começam na mesma altura. Linha sem nenhum selo: sem espaço extra.
   Recalcula quando a largura do grid muda (celular, tablet, computador) e quando o grid é
   trocado (filtros, ordenação, paginação).
   ============================================ */

(() => {
  const SPACE_CLASS = 'versale-card--badge-space';
  const BADGE_SELECTOR = ':scope > .product-item__info > .product-item-meta > .moissanite-badge';
  const observedLists = new WeakMap(); // lista -> última largura alinhada

  const hasBadge = (card) => card.querySelector(BADGE_SELECTOR) !== null;

  const alignList = (list) => {
    const rows = new Map();

    list.querySelectorAll(':scope > .versale-card').forEach((card) => {
      const top = card.offsetTop;
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(card);
    });

    rows.forEach((rowCards) => {
      const rowHasBadge = rowCards.some(hasBadge);
      rowCards.forEach((card) => card.classList.toggle(SPACE_CLASS, rowHasBadge && !hasBadge(card)));
    });
  };

  // Só a largura muda as linhas; a altura muda com a própria classe e não precisa recalcular
  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach(({ target, contentRect }) => {
      if (observedLists.get(target) === contentRect.width) return;
      observedLists.set(target, contentRect.width);
      alignList(target);
    });
  });

  // Lista nova: passa a ser observada (o ResizeObserver alinha na hora).
  // Lista já observada que recebeu cards novos (filtro, ordenação): alinha de novo.
  const scan = () => {
    document.querySelectorAll('.product-list__inner').forEach((list) => {
      if (!list.querySelector(':scope > .versale-card')) return;

      if (observedLists.has(list)) {
        alignList(list);
      } else {
        observedLists.set(list, null);
        resizeObserver.observe(list);
      }
    });
  };

  const containsCard = (node) => node.nodeType === 1 && (node.matches('.versale-card') || node.querySelector('.versale-card') !== null);

  let scanQueued = false;
  new MutationObserver((records) => {
    if (scanQueued || !records.some((record) => Array.from(record.addedNodes).some(containsCard))) return;
    scanQueued = true;
    requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  }).observe(document.body, { childList: true, subtree: true });

  scan();
})();
